import SwapWithRouter from "./swap-new"
import { SimpleAgentProvider } from "../contexts/simple-agent"

export default function SwapBase() {
  return (
    <SimpleAgentProvider>
      <SwapWithRouter />
    </SimpleAgentProvider>
  )
}
